// extracted by mini-css-extract-plugin
export default {"btnBox":"fUnhjS0V_DxhJ3dyIFvf"};